@if (action().actionType == 'link') {
  <a [routerLink]="getLink(action().method)" [queryParams]="getParams(action().method)"
     (click)="modalWindowService.clearModalUrls(); modalWindowService.clearFormMethod()">
    <app-ui-btn [ngStyle]="fullWidth() ? {} : { display: 'inline-flex' }" [btnType]="action().button?.btnType"
                [size]="action().button?.size"
                [tooltip]="action().button?.tooltip | translation"
                [color]="action().button?.color" [icon]="action().button?.icon"
                [iconColor]="action().button?.iconColor" [iconSize]="action().button?.iconSize">
      <ng-content></ng-content>
    </app-ui-btn>
  </a>
}
